import { useTranslation } from '@e-kyc/translations';

import { Button } from '../../../../../../components';

interface IdCardConfirmationFooterProps {
  onSubmit: () => void;
  onRetake: () => void;
}

export function IdCardConfirmationFooter(props: Readonly<IdCardConfirmationFooterProps>) {
  const { onSubmit, onRetake } = props;
  const { t } = useTranslation();

  return (
    <div className='sticky bottom-0 z-100 flex h-fit w-full gap-4 bg-white px-4 pt-4 pb-8'>
      <Button variant='outlined' className='cursor-pointer' fullWidth onClick={onRetake}>
        {t('idCardDetails.button.retake')}
      </Button>
      <Button className='cursor-pointer' fullWidth onClick={onSubmit}>
        {t('idCardDetails.button.submit')}
      </Button>
    </div>
  );
}
